export default "__VITE_ASSET__Bwkkd83k__"